<template>
	<div v-if="isSolidMeshConstruction" class="shape-type-switch-panel">
		<v-btn icon @click="selectShape('box')" :title="$t('SHAPE_CUBE')" :class="{ 'active-button': selectedShapeType === 'box' }">
			<v-icon>mdi-cube-outline</v-icon>
		</v-btn>
		<v-btn icon @click="selectShape('sphere')" :title="$t('SHAPE_SPHERE')"
			:class="{ 'active-button': selectedShapeType === 'sphere' }">
			<v-icon>mdi-sphere</v-icon>
		</v-btn>
		<v-btn icon @click="selectShape('cylinder')" :title="$t('SHAPE_CYLINDER')"
			:class="{ 'active-button': selectedShapeType === 'cylinder' }">
			<v-icon>mdi-cylinder</v-icon>
		</v-btn>
	</div>
</template>

<script>
import { InProgressMode } from "@/store/modules/inprogress-mode-manager";
import { mapState } from "vuex";

const primitiveShapeTypes = ["box", "sphere", "cylinder"];

export default {
	name: "ShapeTypeSwitchPanel",
	computed: {
		...mapState("solidMesh", ["selectedShapeType"]),
		...mapState("inProgressModeManager", ["inProgressMode", "objectType"]),
		isSolidMeshConstruction() {
			return (
				this.inProgressMode === InProgressMode.CREATION &&
				this.objectType === "SolidMesh" &&
				primitiveShapeTypes.includes(this.selectedShapeType)
			);
		},
	},
	methods: {
		selectShape(type) {
			try {
				this.$store.getters.viewer?.setSolidMeshConstructionShapeType(type);
				this.$store.commit("solidMesh/setSelectedShapeType", type);
			} catch (e) {
				console.error("Failed to switch shape type:", e);
			}
		},
	},
};
</script>

<style scoped>
.shape-type-switch-panel {
	position: absolute;
	top: 60px;
	left: 10px;
	z-index: 1;
	display: flex;
	flex-direction: row;
	gap: 8px;
	background-color: rgba(0, 0, 0, 0.5);
	padding: 8px;
	border-radius: 4px;
}

.shape-type-switch-panel .v-btn {
	min-width: 36px;
	width: 36px;
	height: 36px;
	background-color: rgba(50, 50, 50, 0.7);
	border: 1px solid rgba(100, 100, 100, 0.9);
	color: white;
}

.shape-type-switch-panel .v-btn:hover:not(.active-button):not(:disabled) {
	background-color: rgba(70, 70, 70, 0.8);
}

.shape-type-switch-panel .v-btn.active-button {
	background-color: #1976D2;
}

.shape-type-switch-panel .v-icon {
	color: white;
}
</style>
